import { gql } from "lib/apolloClient";

import {
  teacherItemDetailFragment,
  staffPermissionFragments,
  basicUserFragment,
} from "./ReviewerSetupFragments";

export const getStaffRoleAccessFeedQuery = gql`
  query getStaffRoleAccessFeed(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $permissionCurriculumId: ID
    $entityRelationMapFilters: EntityRelationMapFilter
    $courseFilters: CourseFilter
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        staff(
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          userCount {
            role
            totalCount
            __typename
          }
          edges {
            node {
              id
              ... on Staff {
                displayRole
                curriculumDefaultAccess(
                  curriculumProgramId: $permissionCurriculumId
                )
                ...teacherItemDetail
                ...staffPermissions
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${teacherItemDetailFragment.teacherItemDetails}
  ${staffPermissionFragments.staffPermissions}
`;

export const getAllStaffMembersQuery = gql`
  query getStaffMembers(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        staff(filters: $filters) {
          edges {
            node {
              ...basicUserItem
            }
          }
        }
      }
    }
  }
  ${basicUserFragment}
`;

export const getDefaultReviewerSettingsQuery = gql`
  query getDefaultReviewSettings(
    $organizationId: ID!
    $input: DefaultReviewSettingsInput!
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        defaultReviewSettings(input: $input) {
          curriculumProgramId
          defaultReviewSettings
          defaultReviewers {
            id
            firstName
            lastName
            middleName
          }
        }
      }

      __typename
    }
  }
`;
